module.exports = __webpack_public_path__ + "static/joaoccm-ca4ccc0ff58a836ed68868e6e2169e99.jpg";